import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Elements } from 'react-stripe-elements';
import PaymentForm from './PaymentForm.js';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  withRouter,

} from 'react-router-dom'

const countries = [
  {
    value: 'US',
    label: 'United States',
  },
  {
    value: 'AR',
    label: 'Argentina',
  },
  {
    value: 'CH',
    label: 'Chile',
  },
  {
    value: 'PR',
    label: 'Perú',
  },
];




const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  button: {
    // margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    width: '100%',
    // lineHeight: 1.5,
    backgroundColor: 'rgb(37,106,167)',
    borderColor: 'rgb(37,106,167)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },
  buttonBack: {

    textTransform: 'none',
    fontSize: 16,
    padding: '3px 6px',
    color: '#203b60',
    width: '100%',
    backgroundColor: '#f2f2f2',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),

  },


  error: {
    backgroundColor: theme.palette.error.dark,
  },
  textFieldLabel: {
    // color: "red",
    textAlign: "left",
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    // // width: 50,

    color: "#203b60",
    textAlign: "left",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  MtextField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    // width: 50,

    color: "#203b60",
    fontSize: "18px",
    textAlign: "left",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  paperRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginBottom: '15px',
    width: '100%',

  },
  paperImp: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: '15px'
    // width:'100%'
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    flexDirection: 'row'
  },
  root: {
    padding: 0,
    marginBottom: '1px'
  },
  commonMargin: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2
  }


});

class AddressForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      company: "",
      address_line1: "",
      address_zip: "",
      address_city: "",
      address_country: "",
      email: "",
      payment_method: "",
      countries_options: [],
      email_validation: ""
    }
    this.handleTextField = this.handleTextField.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.submit = this.submit.bind(this);
    this.getCountries = this.getCountries.bind(this)
    this.emailValidchange = this.emailValidchange.bind(this);
  }


  handleTextField(event) {
    console.log("handling text field")
    const name = event.target.name;
    this.setState({
      [name]: event.target.value
    });

  }

  componentDidMount() {
    window.scrollTo(0, 0)
    if (this.props.history.location.state) {
      this.setState(this.props.history.location.state.data.form)
    }

    this.getCountries()


  }

  submit(e) {
    e.preventDefault()

    this.nextStep()


  }

  nextStep(token) {
    this.props.nextStep({
      token: token,
      form: this.state
    })
  }

  getCountries() {

    if (this.state.address_country === "") {
      console.log("Busque los paises")
      fetch('/api/kalenis_web/get_countries')
        .then(response => response.json())
        .then(data => {



          this.setState({ countries_options: data })

        })
        .catch(error => console.error(error))

    }

  }

  emailValidchange(event) {
    console.log("Email Valid Change")

    console.log(event.target.value)
    console.log(this.state.email)
    if (this.state.email == event.target.value) {
      event.target.setCustomValidity("")
      this.handleTextField(event)
    }
    else {
      event.target.setCustomValidity("Ha ingresado dos direcciones de correo diferentes");
    }
  }

  render() {
    const { classes } = this.props;
    return (

      <React.Fragment>
        {/* <Typography variant="h6" gutterBottom> */}
        <form onSubmit={this.submit}>
          <div className="pricing-title">Datos de facturación</div>
          {/* </Typography> */}
          <Grid container spacing={24}>
            <Grid item xs={12} >
              <TextField
                required
                id="company"
                name="company"
                label="Empresa"
                fullWidth
                // autoComplete="fname"
                value={this.state.company}
                onChange={this.handleTextField}
                InputProps={{
                  classes: {
                    root: classes.textField,
                    input: { textAlign: 'left' }
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldLabel,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="address_line1"
                name="address_line1"
                label="Dirección"
                required
                fullWidth
                value={this.state.address_line1}
                onChange={this.handleTextField}
                // autoComplete="billing address-line2"
                InputProps={{
                  classes: {
                    root: classes.textField,
                    input: { textAlign: 'left' }
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldLabel,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField

                id="address_country"
                name="address_country"
                label="País"
                required
                fullWidth
                select
                onChange={this.handleTextField}
                value={this.state.address_country}
                InputProps={{
                  classes: {
                    root: classes.textField,
                    input: { textAlign: 'left' }
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldLabel,
                  },
                }}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
              >

                {this.state.countries_options.map(country => (
                  <MenuItem key={country.id} value={country}>
                    {country.name}
                  </MenuItem>
                ))}

              </TextField>


            </Grid>




            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="address_city"
                name="address_city"
                label="Ciudad"
                fullWidth
                onChange={this.handleTextField}
                value={this.state.address_city}
                InputProps={{
                  classes: {
                    root: classes.textField,
                    input: { textAlign: 'left' }
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldLabel,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="address_zip"
                name="address_zip"
                label="Código Postal"
                fullWidth
                onChange={this.handleTextField}
                value={this.state.address_zip}

                InputProps={{
                  classes: {
                    root: classes.textField,
                    input: { textAlign: 'left' }
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldLabel,
                  },
                }}
              />
            </Grid>







            <Grid item xs={12}>
              <TextField
                id="email"
                name="email"
                label="E-Mail"
                type="email"
                fullWidth
                required
                value={this.state.email}
                onChange={this.handleTextField}
                InputProps={{
                  classes: {
                    root: classes.textField,
                    input: { textAlign: 'left' }
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldLabel,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="email_validation"
                name="email_validation"
                label="Confirmar E-Mail"
                type="email"
                fullWidth
                required
                autocomplete="off"
                // value={this.state.email_validation}
                // onChange={this.handleTextField}

                onChange={this.emailValidchange}

                InputProps={{
                  classes: {
                    root: classes.textField,
                    input: { textAlign: 'left' }
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.textFieldLabel,
                  },
                }}
              />
            </Grid>








          </Grid>



          <Grid>

            <Grid style={{ paddingTop: "30px", paddingBottom: "10px" }} item xs={12}>
              <div className="pricing-title"> Datos de pago</div>
            </Grid>
            <Grid item xs={12}>


              <Grid item xs={12}>
                <div className={classes.textField} style={{ textAlign: 'left', marginRight: "2px", color: 'rgba(0, 0, 0, 0.54)' }} >Medio de Pago:</div>
              </Grid>

              <Grid item xs={12}>
                <RadioGroup
                  aria-label="Payment Method"
                  name="payment_method"
                  required
                  className={classes.group}
                  value={this.state.payment_method}
                  onChange={this.handleTextField}
                >

                  <FormControlLabel value="credit" control={<Radio color="primary" />} label="Tarjeta de Crédito" />
                  <FormControlLabel value="transfer" control={<Radio color="primary" />} label="Transferencia Bancaria" />

                </RadioGroup>
              </Grid>
            </Grid>

            {this.state.payment_method === 'credit' &&
              <Elements><PaymentForm form_info={this.state} back={this.props.back} nextStep={this.nextStep} /></Elements>
            }
            {this.state.payment_method === 'transfer' &&
              <React.Fragment>
                <div>Al concluir el proceso, recibirá por correo electrónico la información para realizar la transferencia. El servicio será habilitado 24hs luego de la acreditación</div>




                <Grid className={classes.commonMargin} direction='row' alignItems='flex-end' justify='space-between' container spacing={40}>
                  <Grid item xs={12} sm={4}>
                    <Button onClick={this.props.back} variant="contained" className={classes.buttonBack}>
                      <i style={{ marginRight: "8px" }} className="fa fa-1x fa-chevron-left"></i>
                      Volver
                  </Button>
                  </Grid>

                  <Grid item xs={12} sm={4}>

                    <Button type="submit" variant="contained" className={classes.button}>
                      Siguiente
                    <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
                    </Button>

                  </Grid>
                </Grid>










              </React.Fragment>
            }



          </Grid>
        </form>
      </React.Fragment>
    )
  }
}

// export default AddressForm;
export default withSnackbar(withStyles(styles)(withRouter(AddressForm)));
// export default injectStripe(AddressForm)

